import React, { useState } from 'react';
import { useCompany } from '../context/CompanyContext';
import { Toast } from '../components/UI';

export default function OnboardingScreen() {
    const { selectCompany } = useCompany();
    const [companyId, setCompanyId] = useState('');
    const [loading, setLoading] = useState(false);

    const handleConnect = async (e) => {
        e.preventDefault();
        const id = companyId.trim();
        if (!id) { Toast.show({ type: 'error', text1: 'Enter a Company ID' }); return; }
        setLoading(true);
        try {
            await selectCompany(id);
            Toast.show({ type: 'success', text1: 'Connected!' });
        } catch (err) {
            Toast.show({ type: 'error', text1: err.message || 'Company not found' });
        } finally {
            setLoading(false);
        }
    };

    return (
        <div style={{
            minHeight: '100vh', backgroundColor: 'var(--bg-primary)', display: 'flex',
            flexDirection: 'column', alignItems: 'center', justifyContent: 'center', padding: 24
        }}>
            <div style={{ width: '100%', maxWidth: 400 }}>
                {/* Logo */}
                <div style={{ textAlign: 'center', marginBottom: 40 }}>
                    <div style={{
                        width: 80, height: 80, borderRadius: '50%', backgroundColor: 'var(--brand-500)',
                        display: 'flex', alignItems: 'center', justifyContent: 'center',
                        margin: '0 auto 16px', fontSize: 40, fontFamily: 'var(--font-display)', fontWeight: 800,
                        color: '#fff',
                    }}>G</div>
                    <h1 style={{
                        fontFamily: 'var(--font-display)', fontSize: 28, fontWeight: 800,
                        color: 'var(--brand-300)', letterSpacing: 2
                    }}>GAAFCRM</h1>
                    <p style={{ color: 'var(--text-muted)', fontSize: 13, marginTop: 4 }}>Your AI Agent</p>
                </div>

                {/* Form card */}
                <div style={{
                    backgroundColor: 'var(--bg-card)', borderRadius: 20, padding: 24,
                    border: '1px solid var(--border)', marginBottom: 16
                }}>
                    <h2 style={{
                        fontFamily: 'var(--font-display)', fontSize: 20, fontWeight: 700,
                        marginBottom: 4
                    }}>Connect to a Business</h2>
                    <p style={{ color: 'var(--text-muted)', fontSize: 13, marginBottom: 20, lineHeight: 1.5 }}>
                        Enter the Company ID provided by the Business you want to interact with.
                    </p>
                    <form onSubmit={handleConnect}>
                        <label style={{
                            display: 'block', color: 'var(--text-muted)', fontSize: 11,
                            fontWeight: 600, textTransform: 'uppercase', letterSpacing: '0.5px', marginBottom: 4
                        }}>
                            Company ID
                        </label>
                        <input
                            value={companyId}
                            onChange={e => setCompanyId(e.target.value)}
                            placeholder="e.g. comp-abc123"
                            autoCapitalize="none"
                            autoCorrect="off"
                            style={{
                                display: 'block', width: '100%', backgroundColor: 'var(--bg-input)',
                                border: '1px solid var(--border)', borderRadius: 10,
                                padding: '12px 14px', color: 'var(--text-primary)', fontSize: 15,
                                marginBottom: 16, fontFamily: 'var(--font-body)',
                            }}
                        />
                        <button type="submit" disabled={loading} style={{
                            width: '100%', backgroundColor: loading ? 'var(--brand-700)' : 'var(--brand-500)',
                            color: '#fff', border: 'none', borderRadius: 10, padding: '12px',
                            fontSize: 15, fontWeight: 700, cursor: loading ? 'not-allowed' : 'pointer',
                            fontFamily: 'var(--font-body)', transition: 'background 0.15s',
                        }}>
                            {loading ? 'Connecting…' : 'Connect'}
                        </button>
                    </form>
                </div>

                {/* Divider */}
                <div style={{ display: 'flex', alignItems: 'center', gap: 12, marginBottom: 16 }}>
                    <div style={{ flex: 1, height: 1, backgroundColor: 'var(--border)' }} />
                    <span style={{ color: 'var(--text-muted)', fontSize: 13 }}>or</span>
                    <div style={{ flex: 1, height: 1, backgroundColor: 'var(--border)' }} />
                </div>

                {/* Info card */}
                <div style={{
                    backgroundColor: 'var(--bg-card)', borderRadius: 20, padding: 24,
                    border: '1px solid var(--border)'
                }}>
                    <h3 style={{
                        fontFamily: 'var(--font-display)', fontSize: 17, fontWeight: 700,
                        marginBottom: 8
                    }}>What is GAAFCRM?</h3>
                    <p style={{ color: 'var(--text-muted)', fontSize: 13, lineHeight: 1.6, marginBottom: 16 }}>
                        Book Appointments, Place Orders, Buy Event and Flight Tickets, and Chat
                        with an AI Agent — All without making a phone call.
                    </p>
                    <div style={{ display: 'flex', flexWrap: 'wrap', gap: 8 }}>
                        {['📅 Appointments', '🛍 Orders', '🎟 Events', '✈️ Flights'].map(f => (
                            <span key={f} style={{
                                backgroundColor: 'var(--bg-surface)', borderRadius: 'var(--radius-full)',
                                padding: '4px 12px', color: 'var(--brand-200)', fontSize: 12, fontWeight: 600,
                            }}>{f}</span>
                        ))}
                    </div>
                </div>
            </div>
        </div>
    );
}
